import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { DateFormats } from "@common/ux/date-formats";

@Pipe({
    name: "adaptDateTime",
    standalone: false,
})
export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
    public transform(value: any): any {
        return super.transform(value, DateFormats.globalize.shortdatetime);
    }
}
